import { createAction } from '@reduxjs/toolkit';

export const setIsDelegate = createAction<boolean | null>('reviewsDelegate/setIsDelegate');